<template>
  <v-dialog v-model="dialog" persistent width="780px" height="980px" content-class="lineFriendStatusDialog dashboardTblComponent">
    <div class="layerPopup">
      <div class="layerTit">
        友達追加状況
      </div>
      <div class="layerContent">
        <div class="bottomSpace">
          <table class="UXTbl tblHover mt-3">
            <colgroup>
              <col v-for="(header, index) in lineFriendHeader" :key="index" :style="{ width: header.width }">
            </colgroup>
            <thead>
            <tr>
              <th v-for="(header, index) in lineFriendHeader" :key="index">{{ header.text }}</th>
            </tr>
            </thead>
            <tbody class="linefriendBody">
              <tr v-for="(data, index) in friendDatas" :key="index">
                <td class="bold">{{ dateAddWeekday(data.targetDate) }}</td>
                <td>{{ data.prevDayDiff }}</td>
                <td>{{ data.followCount }}</td>
                <td>{{ data.unFollowCount }}</td>
                <td>{{ data.useFollowCount }}</td>
              </tr>
            </tbody>
          </table>
          <div class="changePage">
            <i class="UXicon-arrow_left cursor" :class="{'not': this.page === 0}"  @click="movePage(-1)"></i>
            <span class=pr-5 :class="{'not': this.page === 0}">1週間後</span>
            <span class=pl-5>1週間前</span>
            <i class="UXicon-arrow_right cursor" @click="movePage(1)"></i>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="cancel()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import helper from 'util/helpers'

export default {
  name: 'lineFriendStatusDialog',
  components: {
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    lineFriendHeader: {
      type: Array
    },
    brandId: {
      type: Number
    },
    lineChannel: {
      type: Number
    }
  },
  data () {
    return {
      disabled: false,
      page: 0,
      pagList: [5, 10, 15],
      temp: {
        targetDate: '',
        prevDayDiff: 0,
        followCount: 0,
        unFollowCount: 0,
        useFollowCount: 0
      },
      friendDatas: []
    }
  },
  computed: {
    ...mapGetters([
      'currentBrandId'
    ])
  },
  watch: {
    dialog (val) {
      if (val) {
        this.getAllFollowrsTable()
      }
    }
  },
  mounted () {
    this.getAllFollowrsTable()
  },
  methods: {
    cancel () {
      this.$emit('dialogControl')
    },
    getAllFollowrsTable () {
      let startDate = this.$moment(new Date()).subtract(6 * (this.page), 'days').format('YYYYMMDD')
      let endDate = this.$moment(new Date()).subtract(6 * (this.page + 1), 'days').format('YYYYMMDD')
      this.$http({
        method: 'GET',
        url: 'api/brandLineStatus/getFollowCount',
        params: {
          brandId: this.brandId,
          endDate: startDate,
          startDate: endDate,
          moduleChannelId: this.lineChannel
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.friendDatas = res.data.data
        }
      })
    },
    dateAddWeekday (date) {
      return helper.printTimeStampMMMDoddFromDateTime(date)
    },
    movePage (index) {
      this.page += index
      if (this.page < 1) {
        this.page = 0
      }
      this.getAllFollowrsTable()
    }
  }
}
</script>

<style scoped lang="scss">
.lineFriendStatusDialog {
  position: relative;
  padding: 20px 24px;
  border-radius: 5px;
  background-color: #fff;
  overflow: auto;
  .layerPopup {
    .layerContent {
      padding: 0px;
      .bottomSpace {
        .UXTbl{
          th {
            padding: 0;
            height: 50px;
            text-align: center;
            font-size: 12px;
            font-weight: 400 !important;
            border-top: 1px solid #dcdcdc !important;
            background-color: #EBEBEB;
          }
          td {
            padding: 0;
            height: 50px;
            text-align: center;
            font-size: 12px;
            font-weight: 400 !important;
            border-top: 1px solid #dcdcdc !important;
            &.bold {
              font-weight: 700 !important;
            }
          }
        }
        .changePage {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 20px;
          span {
            font-size: 12px;
            font-weight: 700;
          }
          .not {
            opacity: 0.5;
            cursor: default;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/fragments/lineFriendStatusDialog.vue